export default  {
  title: "Nieuw wachtwoord instellen",
  warning: {
    noPassword: "Voer het nieuwe wachtwoord in.",
    noMatch: "De wachtwoorden komen niet overeen.",
    noToken: "Controleer de e-mail alstublieft, het token ontbreekt."
  },
  error: {
    wrongToken: "Controleer de e-mail alstublieft, het token klopt niet.",
    passwordEncryption: "Uw wachtwoord kon niet versleuteld worden.",
  },
  success: {
    passwordChanged: "Het wachtwoord is bijgewerkt, Je kan weer inloggen!",
  },

  input: {
    password: {
      label: "Wachtwoord"
    },
    passwordRepeat: {
      label: "Herhaal wachtwoord"
    }
  },
  button: {
    submit: "Wachtwoord instellen"
  },

  api: {
    error: {
      token: {
        invalid: "Controleer uw e-mail, de token is incorrect",
        isUsed: "Token is al gebruikt, vraag opnieuw een wachtwoord aan",
        expired: "Token is verlopen, vraag opnieuw een wachtwoord aan",
      },
    },
  },
}
